import type { ImageMapWrapperProps } from './interfaces';
import ImageMap from '@/uikit/components/ImageMap/ImageMap';

const ImageMapWrapper = ({ image, ...props }: ImageMapWrapperProps) => {
  return image && image.path ? <ImageMap image={image} {...props} /> : null;
};

export default ImageMapWrapper;
